import React, { useEffect } from 'react'
import useCompanies from '../../hooks/useCompanies';
import Loader from '../../components/Loader';
import Table from './Table';
import FormModal from './FormModal';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import api from '../../app/api';
import useAlert from '../../hooks/useAlert';
import { DeleteAlert } from '../../components/Swal Alert';
import { getTabPaneClassName } from './tabUtils';

const Team = ({ company, tab, isManager, branchID }) => {
    const labels = ['#', 'Name', 'Email', 'Actions'];
    const {
        // loading,
        // deleteLoading,
        // addLoading,
        data,
        setData
    } = useCompanies();
    const [loading, setLoading] = useState(null)
    const [deleteLoading, setDeleteLoading] = useState(null)
    const [profileEmails, setProfileEmails] = useState([])
    const { showAlert } = useAlert()
    const removeEmail = async (item) => {
        if(!await DeleteAlert()) return
        setDeleteLoading(item)
        try {
            const response = await api.delete(`/profile-email/delete`, { params: { _id: item._id } });
            if (response.data?.status) {
                showAlert('email deleted successfully.', 'success')
                fetchEmail(response.data?.result)
            } else {
                showAlert(response.data.message, 'danger')
            }
        } catch (error) {

        }finally{
            setDeleteLoading(null)
        }
    }
    const addEmail = async () => {
        setLoading('add')
        try {
            const response = await api.post(`/profile-email/add`, { userID: localStorage.getItem('_id'), email: data.email, name: data.name });
            if (response.data?.status) {
                showAlert('Email added Successfully.', 'success')
                fetchEmail(response.data?.result)
                setData({ show: false })
            } else {
                showAlert(response.data.message, 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        }finally{
            setLoading(null)
        }
    }
    const changeEmail = async () => {
        setLoading('add')
        try {
            const response = await api.put(`/profile-email/update`, { _id: data._id, email: data.email, name: data.name });
            if (response.data?.status) {
                showAlert('Email updated successfully.', 'success')
                fetchEmail(response.data?.result)
                setData({ show: false })
            } else {
                showAlert(response.data.message, 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        }finally{
            setLoading(null)
        }
    }
    const fetchEmail = async () => {
        setLoading('new')
        try {
            const response = await api.get(`/profile-email/`, { params: { userID: localStorage.getItem('_id') } });
            setProfileEmails(response.data?.result)
        } catch (error) {

        }finally{
            setLoading(null)
        }
    }
    const navigator = useNavigate()
    useEffect(() => {
        if (company?._id && tab?.includes('profileEmail'))
            fetchEmail()
    }, [company, tab])

    const isUpdate = !!data?._id;

    const fields = [
        {
            placeholder: 'Name',
            value: data?.name,
            setValue: (value) => setData({ ...data, name: value }),
            className: 'col-md-6'
        },
        {
            placeholder: 'Email',
            value: data?.email,
            setValue: (value) => setData({ ...data, email: value }),
            className: 'col-md-6'
        },
    ].filter(item => item)

    return (
        <div className={getTabPaneClassName(tab, "#profile-manage-profileEmail")} id="profile-manage-profileEmail">
            <div className="table-container">
                <Loader loading={loading=='new'} center>
                    <Table
                        labels={labels}
                        data={profileEmails?.map(item => ({
                            cells: [item?.name, item?.email],
                            data: item
                        }))}
                        onDelete={removeEmail}
                        onEdit={(item) => setData({ ...item, show: true })}
                        onAdd={() => setData({ show: true })}
                        deleteLoading={deleteLoading}
                    />
                </Loader>
            </div>
            <FormModal
                show={data.show == true}
                title={isUpdate ? 'Update Email' : 'New Email'}
                onSubmit={isUpdate ? () => changeEmail(company?._id) : () => addEmail(company?._id)}
                fields={fields}
                onClose={() => setData({ ...data, show: false })}
                loading={loading == 'add'}
            />
        </div>
    )
}

export default Team